module.exports = __webpack_public_path__ + "img/disk.70030a06.png";